import Flickity from 'flickity';
import {register} from './../vendor/theme-scripts/theme-sections';
import editorialSection from './editorial';

const selectors = {
  dataSectionId: 'data-section-id',
  blogListing: '.blog-listing',
  flickityEnabled: 'flickity-enabled',
};

const sections = {};

class Blog {
  constructor(section) {
    this.container = section.container;
    this.id = this.container.getAttribute(selectors.dataSectionId);
    this.slideshow = this.container.querySelector(selectors.blogListing);
    this.flkty = null;

    this.init();
  }

  init() {
    const self = this;

    this.flkty = new Flickity(this.slideshow, {
      autoPlay: false,
      prevNextButtons: true,
      contain: true,
      pageDots: false,
      wrapAround: true,
      watchCSS: true,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 40,
        x3: 20,
      },
    });
  }

  setHeights(container) {
    const content = container.querySelectorAll('.featured-blog__content');
    let flag = false;

    if (content.length > 0) {
      for (const element of content) {
        if (element.classList.contains('onboarding-blog-content')) {
          flag = true;
          break;
        }
      }

      if (flag) {
        let tallestContent = 0;

        for (const element of content) {
          const title = element.querySelector('.h5');
          const titleHeight = parseInt(getComputedStyle(title, null).height.replace('px', ''));
          const dateEl = element.querySelectorAll('.featured-blog__date');
          const dateHeight = parseInt(getComputedStyle(dateEl, null).height.replace('px', ''));
          const excerptEl = element.querySelector('.excerpt');
          const excerptHeight = parseInt(getComputedStyle(excerptEl, null).height.replace('px', ''));
          const currentContent = titleHeight + dateHeight + excerptHeight;
          if (currentContent > tallestContent) {
            tallestContent = currentContent;
          }
        }

        tallestContent += 75;
        for (const element of content) {
          element.style.height = `${tallestContent}px`;
        }
      }
    }
  }

  onBlockSelect(evt) {}

  onUnload(evt) {
    if (this.slideshow.classList.contains(selectors.flickityEnabled)) {
      this.flkty.destroy();
    }
  }
}

const blogSection = {
  onLoad() {
    sections[this.id] = new Blog(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('blog-template', [blogSection, editorialSection]);
register('blog', blogSection);
